import { AccessDeps } from 'features/Access/infra/react/AccessState'
import { restClient } from 'presentation/libs/client'

export const logout: AccessDeps['logout'] = async () =>
  await restClient.post('logout')
    .json()
